export default {
  data () {
    return {
      dateRangesFilter: null
    }
  },
  mounted () {
    this.dateRangesFilter = this.dateRanges()
  },
  methods: {
    dateRanges () {
      let now = Date.now()
      let day = new Date(now)
      day.setSeconds(0)
      day.setMinutes(0)
      day.setHours(0)
      let week = new Date(now - (1000 * 60 * 60 * 24 * 6))
      week.setSeconds(0)
      week.setMinutes(0)
      week.setHours(0)
      let month = new Date(now - (1000 * 60 * 60 * 24 * 29))
      month.setSeconds(0)
      month.setMinutes(0)
      month.setHours(0)
      return [
        {value: month.toISOString(), name: this.$tr('Miesiąc', 'ReturnList')},
        {value: week.toISOString(), name: this.$tr('Tydzień', 'ReturnList')},
        {value: day.toISOString(), name: this.$tr('Dzień', 'ReturnList')}
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/date-ranges.js